import { RepresentativeProfileRegisterContainer } from './components/RepresentativeProfileRegisterContainer';

export const RepresentativeProfileRegisterPage = RepresentativeProfileRegisterContainer;
